import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Avatar, Box, Button, Grid, Stack, Typography } from "@mui/material";

import AgentOffices from "./AgentOffices";
import { Loader } from "../../common/loader";
import { getFormatedPhoneNumber } from "../../helpers/utils";
import CommonAgentsAdminTable from "./CommonAgentsAdminTable";
import { agentsAdminAction } from "../../../redux/slices/brokers/agentAdminSlice";

const columns = [
  {
    key: 1,
    label: "",
    id: "full_name",
    bodypadding: "8px",
  },
  {
    key: 2,
    label: "",
    id: "phone",
    bodypadding: "8px",
  },
];

const SalesManagerOverview = ({ base_route }) => {
  const dispatch = useDispatch();

  const { brokerDetails } = useSelector((state) => state?.brokerAgents);
  const { salesRepresentativeList, agentProfileListData, agentRepLoader } =
    useSelector((state) => state?.agentsAdmin);
  const smProfileData = agentProfileListData?.success
    ? agentProfileListData?.data
    : {};
  const brokerData = brokerDetails?.success ? brokerDetails?.data?.broker : {};

  const [isEditOfficeModal, setIsEditOfficeModal] = useState(false);

  useEffect(() => {
    dispatch(
      agentsAdminAction.getSalesRepresentativeDetails({
        url: `sales-manager/representative/list?source=${base_route}`,
        data: {},
        brokertoken: true,
      })
    );
    dispatch(agentsAdminAction.goToRepresentativeTab(false));
  }, []);

  return (
    <div className="billing_wrapper">
      <Grid container spacing={4} className="sm_wrapper">
        {/* Office Details */}
        <Grid item xs={12} md={6}>
          <Typography className="billing_headers mb-5">
            <span>Office Details</span>
          </Typography>

          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Avatar
              src={smProfileData?.office?.logo}
              sx={{ width: 63, height: 43 }}
            />
            <Box>
              <Typography className="sm_header text-capitalize">
                {brokerData?.full_name} {brokerData?.source || base_route}
              </Typography>
              <Typography className="sm_subheader">
                {smProfileData?.office?.office_name} Office
              </Typography>
            </Box>
          </Box>
          <Box>
            <Stack
              // display={"flex"}
              // justifyContent={"flex-start"}
              // alignItems={"center"}
              direction={"row"}
              spacing={2}
            >
              <Box>
                <Typography className="sm_noation" pt={1}>
                  Address:
                </Typography>
                <Typography className="sm_noation" pt={1}>
                  Phone:
                </Typography>
                <Typography className="sm_noation" pt={1}>
                  Email:
                </Typography>
                <Typography className="sm_noation" pt={1}>
                  Fax:
                </Typography>
              </Box>
              <Box>
                <Typography className="sm_header" pt={1}>
                  {smProfileData?.office?.address || "-"}
                </Typography>

                <Typography className="sm_header" pt={1}>
                  {getFormatedPhoneNumber(smProfileData?.office?.phone) || "-"}
                </Typography>
                <Typography className="sm_header" pt={1}>
                  {smProfileData?.office?.email || "-"}
                </Typography>
                <Typography className="sm_header" pt={1}>
                  {smProfileData?.office?.fax || "-"}
                </Typography>
              </Box>
            </Stack>
          </Box>
          <Button
            variant="outlined"
            className="mt-3 agant_edit_btn"
            onClick={() => setIsEditOfficeModal(true)}
          >
            Edit&nbsp;
            <EditOutlinedIcon fontSize="small" />
          </Button>
        </Grid>

        {/* Sales Representatives */}
        <Grid item xs={12} md={6}>
          <Typography className="billing_headers mb-5">
            <span>Sales Representatives</span>
          </Typography>

          <CommonAgentsAdminTable
            columns={columns}
            noheaders={true}
            rowData={
              salesRepresentativeList?.success
                ? (salesRepresentativeList?.data).slice(0, 7)
                : []
            }
            tabelMinWidth={0}
            base_route={base_route}
          />
          <Button
            variant="outlined"
            className="agant_edit_btn text-none"
            size="small"
            sx={{ mt: 2 }}
            onClick={() =>
              dispatch(agentsAdminAction.goToRepresentativeTab(true))
            }
          >
            View all
          </Button>
        </Grid>
      </Grid>
      {isEditOfficeModal && (
        <AgentOffices
          isEditOfficeModal={isEditOfficeModal}
          officeData={smProfileData?.office}
          setIsEditOfficeModal={setIsEditOfficeModal}
        />
      )}
      <Loader open={agentRepLoader} />
    </div>
  );
};

export default SalesManagerOverview;
